import { render } from "./SolarBackground.vue?vue&type=template&id=54bd2793&scoped=true"
import script from "./SolarBackground.vue?vue&type=script&lang=js"
export * from "./SolarBackground.vue?vue&type=script&lang=js"

import "./SolarBackground.vue?vue&type=style&index=0&id=54bd2793&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54bd2793"]])

export default __exports__